import cls from './checkboxList.module.scss';

interface Option {
    value: string;
    label: string;
}

interface Props {
    options: Option[];
    value: string[];
    onChange: (value: string[]) => void;
    type?: 'checkbox' | 'radio';
    emptyLabel?: string;
}

export const CheckboxList = ({ options, value, onChange, type = 'checkbox', emptyLabel }: Props) => {
    const toggle = (id: string) => {
        if (type === 'radio') {
            onChange(value.includes(id) ? [] : [id]);
        } else {
            if (value.includes(id)) {
                onChange(value.filter(v => v !== id));
            } else {
                onChange([...value, id]);
            }
        }
    };

    if (options.length === 0 && emptyLabel) {
        return <div className={cls.list}><p className={cls.empty}>{emptyLabel}</p></div>;
    }

    return (
        <div className={cls.list}>
            {options.map(opt => (
                <label key={opt.value} className={cls.item} onClick={type === 'radio' ? (e) => { e.preventDefault(); toggle(opt.value); } : undefined}>
                    <input
                        type={type}
                        checked={value.includes(opt.value)}
                        onChange={type === 'radio' ? undefined : () => toggle(opt.value)}
                        readOnly={type === 'radio'}
                        className={`${cls.checkbox}`}
                    />
                    <span className={cls.fakeCheckbox}></span>
                    <span>{opt.label}</span>
                </label>
            ))}
        </div>
    );
};